import * as _ from 'underscore'

import { Enums } from '../common/enums'

import { ObjectCustomString } from '..//util/object-custom-string'
import { IOpData, IReferenceType, IOpChangeState, IOpObject, IJsonSerializable, ICopyable } from '../util/interfaces'

import { OpDataList } from '../util/op-data-list'
import { TypeHelper } from '../../helpers'

import { OpSupplierData } from './op-supplier-data'
import { OpFile } from './op-file'


export class OpSupplier implements ICopyable<OpSupplier>, IJsonSerializable, IOpChangeState, IOpObject, IReferenceType {

    //#region Properties

    public idSupplier: number
    public name: string
    public supplierCode: string

    //#endregion


    //#region Navigation Properties


    //#endregion

    //#region Custom Properties

    public currentMessages: OpFile[]

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpSupplier) {
            this.copy(<OpSupplier>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IOpChangeState implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdRoute
    }
    public getReferenceKey(): number {
        return this.idSupplier
    }
    public getReferenceValue(): any {
        return this
    }

    //#endregion


    //#region IOpObject Implementation

    public get idObject(): any {
        return this.idSupplier
    }

    public set idObject(idObject: any) {
        this.idSupplier = idObject
    }

    public dataList: OpDataList<OpSupplierData> = new OpDataList<OpSupplierData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idSupplier = opObj.ID_SUPPLIER
            this.name = opObj.NAME
            this.supplierCode = opObj.SUPPLIER_CODE

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpSupplierData(data)))
            }
            else {
                this.dataList = new OpDataList<OpSupplierData>()
            }

            this.dynamicValues = opObj.dynamicValues

            if (_.size(opObj.currentMessages) > 0) {
                this.currentMessages = opObj.currentMessages.map((file: any) => new OpFile(file))
            }

            this.opState = opObj.OpState
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_SUPPLIER: this.idSupplier,
            NAME: this.name ? this.name : '',
            SUPPLIER_CODE: this.supplierCode ? this.supplierCode : '',

            DataList: this.dataList ? this.dataList.ToJSON() : null,

            currentMessages: _.size(this.currentMessages) > 0 ? this.currentMessages.map((file: OpFile) => file.toJSON()) : null,

            OpState: this.opState
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public copy(source: OpSupplier, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {

        }

        if (includeCustomProperties) {

        }

        if (includeDataList && source.dataList != null) {
            this.dataList = source.dataList.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
        }

        if (includeDynamicValues) {
            this.dynamicValues = TypeHelper.clone(source.dynamicValues, true)
        }

        this.idSupplier = source.idSupplier
        this.name = source.name
        this.supplierCode = source.supplierCode
        this.opState = source.opState
    }

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpSupplier {
        const newSupplier = new OpSupplier(null)

        newSupplier.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newSupplier
    }

    //#endregion


    //#region toString

    public toString(): string {
        const customFormatString: string = ObjectCustomString.getCustomStringFormat(this)

        if (customFormatString == null) {
            return this.name
        }

        return ObjectCustomString.getObjectCustomString(customFormatString, this)
    }

    //#endregion


    //#region loadNavigationProperties

    // public static loadNavigationProperties(dataProvider: DataProvider, list: OpSupplier[]): JQueryPromise<OpSupplier[]> {
    //     return Utils
    //         .loadDataListNavigationProperties(dataProvider, list)
    //         .then(() => {
    //             return dataProvider.System
    //                 .getDictionaries([Enums.ReferenceType.IdSupplier, Enums.ReferenceType.IdRouteStatus])
    //                 .then((dicts: Dictionary<Dictionary<IReferenceType>>) => {
    //                     if (dicts != null) {
    //                         const routeTypeDict: Dictionary<OpRouteType> = dicts.tryGetValue(Enums.ReferenceType.IdRouteType) as Dictionary<OpRouteType>
    //                         const routeStatusDict: Dictionary<OpRouteStatus> = dicts.tryGetValue(Enums.ReferenceType.IdRouteStatus) as Dictionary<OpRouteStatus>

    //                         _.forEach(list, (route: OpRoute) => {
    //                             if (routeTypeDict != null) {
    //                                 route.routeType = routeTypeDict.tryGetValue(route.idRouteType)
    //                             }

    //                             if (routeStatusDict != null) {
    //                                 route.routeStatus = routeStatusDict.tryGetValue(route.idRouteStatus)
    //                             }
    //                         })
    //                     }

    //                     return list
    //                 })

    //         })
    // }

    //#endregion


    //#region fromIOpObject

    public static fromIOpObject(object: IOpObject): OpSupplier {
        const newObject: OpSupplier = new OpSupplier(null)

        newObject.idSupplier = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpSupplierData.fromIOpData(data)))

        return newObject
    }

    //#endregion

}